// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AlertDestinationListQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type AlertDestinationListQuery = {
  __typename?: "GraphqlQuery";
  getAlertDestinations: Array<{
    __typename?: "AlertDestination";
    id: string;
    name: string;
    isDefault: boolean;
    memberCount: number;
    integrations: Array<{
      __typename?: "AlertDestinationIntegration";
      id: string;
      kind: string;
      displayName: string;
    }>;
  }>;
};

export const AlertDestinationListDocument = gql`
  query AlertDestinationList($organizationSlug: ID!) {
    getAlertDestinations(organizationSlug: $organizationSlug) {
      id
      name
      isDefault
      memberCount
      integrations {
        id
        kind
        displayName
      }
    }
  }
`;

/**
 * __useAlertDestinationListQuery__
 *
 * To run a query within a React component, call `useAlertDestinationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertDestinationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertDestinationListQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useAlertDestinationListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  > &
    (
      | { variables: AlertDestinationListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  >(AlertDestinationListDocument, options);
}
export function useAlertDestinationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  >(AlertDestinationListDocument, options);
}
// @ts-ignore
export function useAlertDestinationListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationListQuery,
  AlertDestinationListQueryVariables
>;
export function useAlertDestinationListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationListQuery,
        AlertDestinationListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationListQuery | undefined,
  AlertDestinationListQueryVariables
>;
export function useAlertDestinationListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationListQuery,
        AlertDestinationListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertDestinationListQuery,
    AlertDestinationListQueryVariables
  >(AlertDestinationListDocument, options);
}
export type AlertDestinationListQueryHookResult = ReturnType<
  typeof useAlertDestinationListQuery
>;
export type AlertDestinationListLazyQueryHookResult = ReturnType<
  typeof useAlertDestinationListLazyQuery
>;
export type AlertDestinationListSuspenseQueryHookResult = ReturnType<
  typeof useAlertDestinationListSuspenseQuery
>;
export type AlertDestinationListQueryResult = Apollo.QueryResult<
  AlertDestinationListQuery,
  AlertDestinationListQueryVariables
>;
